import React from 'react'
import {Navigation} from '../components/Navigation'
import {Placeholder, Label, Table, Button, Icon, Card, Transition, Loader} from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {Schedule} from '../components/schedule/schedule.js'
import {default as EventPicker} from '../components/eventpicker/picker.js';
import {Route} from '../components/Router.js'
import * as MarketingdisplaysActions from '../actions/MarketingdisplaysActions.js';
import {env} from '../constants/Environment';
import * as _ from 'lodash';

const moment = require('moment');

const captionsForEventtype = {
    'tdw': 'Tipp der Woche',
    'powerplay': 'Powerplay',
    '1-0-2': '1-0-2'
};

const colorsForEventtype = {
    'tdw': {
        backgroundColor: '#a477c4',
        color: '#FFFFFF'
    },
    'powerplay': {
        backgroundColor: '#3498db',
        color: '#FFFFFF'
    },
    '1-0-2': {
        backgroundColor: '#1abc9c',
        color: '#000000'
    }
};

export default function Marketingdisplays() {
    const [event, setEvent] = React.useState(null);
    const [saving, setSaving] = React.useState(false);
    const [message, setMessage] = React.useState(null);
    const firestore = useFirestore();

    useFirestoreConnect([
        { collection: 'environments/' + env + '/lotteries' }
    ])

    const lotteries = useSelector(({ firestore: { ordered } }) => {
        if(ordered['environments/' + env + '/lotteries']){
            let lsort = _.clone(ordered['environments/' + env + '/lotteries']);
            lsort.sort((a, b) => parseInt(a['id']) - parseInt(b['id']));
        
            return lsort;
        }else{
            return [];
        }
    })

    if(event !== null)
        var eventType = event['is-powerplay']?'powerplay':((event.markets[0]['is-siegerwette'])?'tdw':'1-0-2');

    function saveSchedule(dateStart, data){
        var transformed = {};
        setSaving(true);

        for(var slotIdx in data){
            var slot = data[slotIdx];

            if(typeof slot.items !== 'undefined')
                slot.items.forEach((item) => {
                    let t = item.meta.type;

                    if(typeof item.deleted !== 'undefined' && item.deleted)
                        return;

                    if(typeof transformed[t] === 'undefined')
                        transformed[t] = {};

                    if(typeof transformed[t][slotIdx] === 'undefined')
                        transformed[t][slotIdx] = [];

                    transformed[t][slotIdx].push({
                        id: item.meta.id,
                        'active-from': new Date(item.start * 1000),
                        'active-to': new Date(item.end * 1000)
                    });
                });
        }

        /*if(typeof transformed === 'object')
            for(var type in transformed)
                transformed[type] = { ...Object.values(transformed[type])};

        console.log(transformed);*/

        (async () => {
            await firestore.collection('environments/' + env + '/channels/displays/lotteries/11/schedules').doc(moment.unix(dateStart).format('YYYY-MM-DD')).set(transformed);
            setTimeout(() => {
                setSaving(false);
                showToast('Der Zeitplan wurde gespeichert', 8000);
            }, 1000);
        })();
    }

    function showToast(message, duration){
        setMessage(message);
        setTimeout(() => {
            setMessage(null);
        }, duration);
    }

    function onSelectItem(item){
        (async () => {
            let snapshot = await firestore.collection('environments/' + env + '/programs/0/oe').doc(item.meta.id).get();
            if(snapshot.exists){
                setEvent(snapshot.data());
            }else{
                showToast('Das ausgewählte Event wurde nicht gefunden.', 5000);
            }
            
        })();
    }

  return (
    <Navigation title="Marketing-Displays" icon="film" menu={
        [
        {
            caption: 'Zeitplan für alle Lotterien',
            icon: 'filter',
            entries: (typeof lotteries === 'undefined')?[]:lotteries.map((lottery) => {
                return {
                    caption: lottery.lottery
                }  
            })
        }
        ]
    }>
        <div style={{
                display: 'flex',
                position: 'fixed',
                left: '0px',
                right: '0px',
                bottom: 0,
                top: '41px'
            }}>
                <div style={{
                    backgroundColor: '#EEEEEE',
                    borderRight: '1px solid #CCCCCC',
                    width: '300px',
                    height: '100%',
                    flexGrow: 0,
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {
                        (event === null)?
                    
                            <div style={{
                                margin: '5px'
                            }}>
                                <div style={{
                                    padding: '5px',
                                    color: '#777777'
                                }}>Bitte wählen Sie ein Event aus, um dieses dem Zeitplan hinzuzufügen:</div>
                                <EventPicker onSelectEvent={(event) => {
                                    setEvent(event);
                                }} />
                            </div>
                        :
                            <div style={{
                                margin: '5px'
                            }}>
                                <div style={{
                                    padding: '5px',
                                    color: '#777777'
                                }}>Klicken Sie im Zeitplan die gewünschte Start- und Endzeit an, um das ausgewählte Event dem Zeitplan hinzuzufügen.</div>

                                <Card>
                                    <Card.Content>
                                        <Card.Header>{event.name}</Card.Header>
                                        <Card.Meta>
                                            {moment.unix(event['active-to-utc'].seconds).format('dddd, D. MMMM YYYY [um] HH:mm [Uhr]')}
                                        </Card.Meta>
                                        <Card.Description>
                                            <div>{event.sport.name}</div>
                                            <div>{event.category.name}</div>
                                            <div>{event.tournament.name}</div>
                                            <div>{event.status}</div>

                                        </Card.Description>
                                    </Card.Content>
                                    <Card.Content extra>
                                        <Label style={{
                                            color: colorsForEventtype[eventType].color,
                                            backgroundColor: colorsForEventtype[eventType].backgroundColor
                                        }}>
                                        {
                                            captionsForEventtype[eventType]
                                        }
                                        </Label>
                                    </Card.Content>
                                </Card>

                                <Button fluid icon labelPosition='left' onClick={(e) => setEvent(null) }><Icon name='left arrow' /> Ein anderes Event auswählen</Button>
                            </div>
                    }
                </div>
                <div style={{
                    flexGrow: 1,
                    display: 'flex'
                }}>
                    
                        
                            <Transition.Group animation='slide down' duration={500}>
                            {
                                (message)?
                                <div style={{
                                    position: 'fixed',
                                    top: '40px',
                                    left: '50%',
                                    width: '30%',
                                    marginLeft: '-15%',
                                    backgroundColor: 'rgba(0,0,0,0.8)',
                                    color: '#FFFFFF',
                                    padding: '10px',
                                    textAlign: 'center',
                                    fontSize: '90%',
                                    zIndex: 10
                                }}>
                                    {message}
                                </div>
                            :null
                        }
                        </Transition.Group>
                    {
                        (saving)?
                            <div style={{
                                flexGrow: 1,
                                overflow: 'auto',
                                paddingTop: '20px'
                            }}><Loader active inline='centered' /></div>
                        :
                            <Schedule start={moment().startOf('week').add(1, 'days').format('X')} end={moment().endOf('week').add(1, 'days').format('X')} item={(event === null)?null:{
                                name: event.name,
                                id: event.uid,
                                type: eventType,
                                saving: saving,
                                color: colorsForEventtype[eventType].color,
                                backgroundColor: colorsForEventtype[eventType].backgroundColor
                            }} id={"marketing_displays"} fetch_schedule={function(){
                                    return MarketingdisplaysActions.fetch_schedule(...[firestore, ...arguments]);
                                }} save_schedule={(scheduleId, start, end, lottery, channel, data) => {
                                saveSchedule(start, data);
                            }} onSelectItem={(item) => {
                                onSelectItem(item);
                            }} />
                        
                    }
                </div>
        </div>
    </Navigation>
  )
}